export default "__VITE_ASSET__f52dab94__"